import {
  GET_BACKEND_URL,
  GET_HTTP_CONFIG,
  SET_STRIPE_OBJECT,
  SET_STRIPE_SCRIPT_TAG_STATE,
  SET_PRIVATE_STUDY_PAYMENT_STATE,
  SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE,
  GET_STRIPE_OBJ,
  GET_STRIPE_STANDARD_KEY,
  LOADING_PRISTINE,
  LOADING_STARTED,
  LOADING_COMPLETED_SUCCESS,
  LOADING_COMPLETED_FAILURE,
  INIT_PAYMENT_MODULE,
  LOAD_STRIPE,
  INSTANTIATE_STRIPE,
  PROCESS_PRIVATE_STUDY_PAYMENT,
  SEND_PAYMENT_INFO_TO_BACKEND,
  PROCESS_PUBLIC_STUDY_PAYMENT,
  SET_PUBLIC_STUDY_PAYMENT_STATE,
  SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE,
  GET_STRIPE_LUCID_KEY,
  INSTANTIATE_STRIPE_LUCID,
  SEND_LUCID_PURCHASE_ITEM_TO_BACKEND,
  SEND_LUCID_OBJECT_TO_BACKEND,
  LOAD_CHECKOUT,
  SET_CHECKOUT_SCRIPT_TAG_STATE,
  SET_CHECKOUT_OBJECT,
  INSTANTIATE_CHECKOUT,
  SEND_LUCID_OBJECT_TO_BACKEND_UPDATE,
  RESET_PUBLIC_STUDY_PAYMENT, RESET_PUBLIC_PAYMENT_POST_TO_BACKEND,
} from '../services/constants'
import http from '../services/axios'

import config from '../services/config'

const module = {
  state: {
    scriptTag: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    scriptTagCheckout: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    stripeObj: null,
    checkoutObj: null,
    privatePaymentPostToStripe: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    privatePaymentPostToBackend: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    publicPaymentPostToStripe: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
    publicPaymentPostToBackend: {
      loadingState: LOADING_PRISTINE,
      data: null,
      error: null,
    },
  },
  getters: {
    [GET_STRIPE_STANDARD_KEY]() {
      return config.stripeKey1
      // return `pk_test_E`
    },
    [GET_STRIPE_LUCID_KEY]() {
      return config.stripeKeyLucid
      // return `pk_test_E`
    },
    [GET_STRIPE_OBJ](state) {
      return state.stripeObj
    }
  },
  mutations: {
    [SET_STRIPE_OBJECT](state, payload) {
      state.stripeObj = Stripe(payload)
    },
    [SET_STRIPE_SCRIPT_TAG_STATE](state, payload) {
      state.scriptTag = payload
    },
    [SET_CHECKOUT_SCRIPT_TAG_STATE](state, payload) {
      state.scriptTagCheckout = payload
    },
    [SET_CHECKOUT_OBJECT](state, payload) {
      state.checkoutObj = StripeCheckout.configure(payload)
    },
    [SET_PRIVATE_STUDY_PAYMENT_STATE](state, payload) {
      state.privatePaymentPostToStripe = payload
    },
    [SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE](state, payload) {
      state.privatePaymentPostToBackend = payload
    },
    [SET_PUBLIC_STUDY_PAYMENT_STATE](state, payload) {
      state.publicPaymentPostToStripe = payload
    },
    [SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE](state, payload) {
      state.publicPaymentPostToBackend = payload
    },
    [RESET_PUBLIC_STUDY_PAYMENT](state) {
      state.publicPaymentPostToStripe = {
        loadingState: LOADING_PRISTINE,
        data: null,
        error: null,
      }
    },
    [RESET_PUBLIC_PAYMENT_POST_TO_BACKEND](state) {
      state.publicPaymentPostToBackend = {
        loadingState: LOADING_PRISTINE,
        data: null,
        error: null,
      }
    },
  },
  actions: {
    [LOAD_STRIPE]: (context) => {
      return new Promise((resolve, reject) => {
        try {
          let a = Stripe
          resolve()
        } catch (e) {
          if (context.state.scriptTag.loadingState !== LOADING_PRISTINE) {
            reject(new Error('Stripe has already been loaded'))
          } else {
            context.commit(SET_STRIPE_SCRIPT_TAG_STATE, {
              loadingState: LOADING_STARTED,
              data: null,
              error: null,
            })
            const strpTag = document.createElement('script')
            strpTag.type = 'text/javascript'
            strpTag.async = true
            strpTag.src = 'https://js.stripe.com/v3/'
            strpTag.onload = () => {
              resolve()
            }
            const s = document.getElementsByTagName('script')[0]
            s.parentNode.insertBefore(strpTag, s)
          }
        }
      }).then(() => {
        return context.dispatch(INSTANTIATE_STRIPE).then(() => {
          context.commit(SET_STRIPE_SCRIPT_TAG_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: null,
            error: null,
          })
        })
      })
    },
    [LOAD_CHECKOUT]: (context) => {
      return new Promise((resolve, reject) => {
        try {
          let a = StripeCheckout
          resolve()
        } catch (e) {
          if (context.state.scriptTagCheckout.loadingState !== LOADING_PRISTINE) {
            reject(new Error('Checkout has already been loaded'))
          } else {
            context.commit(SET_CHECKOUT_SCRIPT_TAG_STATE, {
              loadingState: LOADING_STARTED,
              data: null,
              error: null,
            })
            const strpTag = document.createElement('script')
            strpTag.type = 'text/javascript'
            strpTag.async = true
            strpTag.src = 'https://checkout.stripe.com/checkout.js'
            strpTag.onload = () => {
              resolve()
            }
            const s = document.getElementsByTagName('script')[0]
            s.parentNode.insertBefore(strpTag, s)
          }
        }
      }).then(() => {
        context.commit(SET_CHECKOUT_SCRIPT_TAG_STATE, {
          loadingState: LOADING_COMPLETED_SUCCESS,
          data: null,
          error: null,
        })
      })
    },
    [INSTANTIATE_STRIPE]: (context) => {
      context.commit(SET_STRIPE_OBJECT, context.getters[GET_STRIPE_STANDARD_KEY])
    },
    [INSTANTIATE_STRIPE_LUCID]: (context) => {
      context.commit(SET_STRIPE_OBJECT, context.getters[GET_STRIPE_LUCID_KEY])
    },
    [INSTANTIATE_CHECKOUT]: (context, handler) => {
      context.commit(SET_CHECKOUT_OBJECT, handler)
    },
    [PROCESS_PRIVATE_STUDY_PAYMENT]: (context, element) => {
      context.commit(SET_PRIVATE_STUDY_PAYMENT_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })
      return context.state.stripeObj.createToken(element).then((result) => {
        if (result.error) {
          throw new Error(result.error.message)
          // Inform the customer that there was an error.
          // var errorElement = document.getElementById('card-errors')
          // errorElement.textContent = result.error.message
        } else {
          context.commit(SET_PRIVATE_STUDY_PAYMENT_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: result.token.id,
            error: null,
          })
        }
      }).catch(err => {
        context.commit(SET_PRIVATE_STUDY_PAYMENT_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [PROCESS_PUBLIC_STUDY_PAYMENT]: (context, element) => {
      context.commit(SET_PUBLIC_STUDY_PAYMENT_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })
      return context.state.stripeObj.createToken(element).then((result) => {
        if (result.error) {
          throw new Error(result.error.message)
        } else {
          context.commit(SET_PUBLIC_STUDY_PAYMENT_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: result.token.id,
            error: null,
          })
        }
      }).catch(err => {
        context.commit(SET_PRIVATE_STUDY_PAYMENT_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [SEND_PAYMENT_INFO_TO_BACKEND]: (context, {payload, studyId}) => {
      context.commit(SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })

      return http.post(
        context.getters[GET_BACKEND_URL](`studies/${studyId}/checkout`),
        payload,
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        if (response.data.success) {
          context.commit(SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          })
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        context.commit(SET_PRIVATE_PAYMENT_POST_TO_BACKEND_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [SEND_LUCID_PURCHASE_ITEM_TO_BACKEND]: (context, purchaseItem) => {
      context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })

      return http.post(
        context.getters[GET_BACKEND_URL](`studies/${purchaseItem.studyID}/lucid/purchase`),
        purchaseItem,
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        if (response.data.success) {
          context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          })
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [SEND_LUCID_OBJECT_TO_BACKEND]: (context, lucidObject) => {

      context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })

      return http.post(
        context.getters[GET_BACKEND_URL](`studies/${lucidObject.studyID}/lucid/create`),
        lucidObject,
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        if (response.data.success) {
          context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          })
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [SEND_LUCID_OBJECT_TO_BACKEND_UPDATE]: (context, lucidObject) => {

      context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
        loadingState: LOADING_STARTED,
        data: null,
        error: null,
      })

      return http.post(
        context.getters[GET_BACKEND_URL](`studies/${lucidObject.studyID}/lucid/update`),
        lucidObject,
        context.getters[GET_HTTP_CONFIG]
      ).then(response => {
        if (response.data.success) {
          context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
            loadingState: LOADING_COMPLETED_SUCCESS,
            data: response.data,
            error: null,
          })
        } else {
          throw new Error(response.data.message)
        }
      }).catch(err => {
        context.commit(SET_PUBLIC_PAYMENT_POST_TO_BACKEND_STATE, {
          loadingState: LOADING_COMPLETED_FAILURE,
          data: null,
          error: err,
        })
      })
    },
    [INIT_PAYMENT_MODULE]: (context) => {
      const actions = [

        context.dispatch(LOAD_STRIPE),
        context.dispatch(LOAD_CHECKOUT),

      ]
      return Promise.all(actions)
    }
  }
}

export default module
export const paymentModule = module
